module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "parent-and-child"
  }, [_c('dl', {
    staticClass: "box"
  }, [_c('dt', {
    staticClass: "title"
  }, [_vm._v("上级客户")]), _vm._v(" "), (_vm.parent.name) ? _c('dd', {
    staticClass: "item"
  }, [_c('h5', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.parent.name)), _c('em', {
    staticClass: "status"
  }, [_vm._v(_vm._s(_vm.parent.type))])]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("联系电话：" + _vm._s(_vm._f("getFirst")(_vm.parent.phoneArray)))]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("主负责人：" + _vm._s(_vm.parent.manager) + " | 最后访问时间：" + _vm._s(_vm.parent.lastConnectTime))]), _vm._v(" "), (_vm.isDel === 0) ? _c('a', {
    staticClass: "del",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.del(_vm.parent.id, 1)
      }
    }
  }, [_vm._v("删除")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), (!_vm.parent.name && _vm.isDel === 0) ? _c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.addCustomer(1)
      }
    }
  }, [_vm._v("添加上级客户")]) : _vm._e(), _vm._v(" "), _c('dl', {
    staticClass: "box"
  }, [_c('dt', {
    staticClass: "title"
  }, [_vm._v("下级客户")]), _vm._v(" "), _vm._l((_vm.children), function(item) {
    return _c('dd', {
      staticClass: "item"
    }, [_c('h5', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.name)), _c('em', {
      staticClass: "status"
    }, [_vm._v(_vm._s(item.type))])]), _vm._v(" "), _c('p', {
      staticClass: "text"
    }, [_vm._v("联系电话：" + _vm._s(_vm._f("getFirst")(item.phoneArray)))]), _vm._v(" "), _c('p', {
      staticClass: "text"
    }, [_vm._v("主负责人：" + _vm._s(item.manager) + " | 最后访问时间：" + _vm._s(item.lastConnectTime))]), _vm._v(" "), (_vm.isDel === 0) ? _c('a', {
      staticClass: "del",
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          _vm.del(item.id, 0)
        }
      }
    }, [_vm._v("删除")]) : _vm._e()])
  })], 2), _vm._v(" "), (_vm.isDel === 0) ? _c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.addCustomer(0)
      }
    }
  }, [_vm._v("添加下级客户")]) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.modalTitle,
      "visible": _vm.dialogVisible,
      "modal": false,
      "width": "550px"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('el-form', {
    staticStyle: {
      "margin-right": "50px"
    },
    attrs: {
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "选择客户"
    }
  }, [_c('el-autocomplete', {
    staticClass: "v-autocomplete",
    attrs: {
      "fetch-suggestions": _vm.search,
      "placeholder": "搜索或选择"
    },
    on: {
      "select": _vm.handleChange
    },
    model: {
      value: (_vm.customer),
      callback: function($$v) {
        _vm.customer = $$v
      },
      expression: "customer"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v("保 存")])], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.dialogVisible),
      expression: "dialogVisible"
    }],
    staticClass: "v-modal"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cde64ee2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/detail/customer/parent-and-child.vue
// module id = 1344
// module chunks = 82